import { Injectable } from "@angular/core";
import { PessoaJuridica } from "@tivic-team/manager-ts/dist/grl";
import { PessoaJuridicaDTO } from "app/model/dtos/grl/pessoa-juridica.dto";
import { HttpGet, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";

@Injectable()
export class PessoaJuridicaController {
    constructor() {}

    async getPermissionario(filtros?: IFilter): Promise<Array<PessoaJuridica>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/pessoajuridica/permissionarios',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<PessoaJuridica>()
            )
        );

        return await quark.call();
    }

    async getPessoaByCNPJ(nrCnpj: String): Promise<PessoaJuridicaDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/pessoajuridica/:nrCnpj',
                    environment: environment,
                    pathParams: new JSONData({nrCnpj: nrCnpj})
                }),
            }),
            new HttpResponse(
                new PessoaJuridicaDTO()
            )
        );

        return quark.call();
    }
}